// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"CIvqzh7uMA8bNJeW"};